/**
 * Payroll `execute_*` scripts that are allowed in web ZIP / archival mode.
 * They delegate to createWebArchivePayrollBridge (noop success); outputs must already exist in the ZIP.
 */
export const WEB_ARCHIVE_NOOP_EXECUTE_SCRIPTS = new Set<string>([
  "execute_ipe_testing",
  "execute_exception_sharepoint",
  "execute_headcount_sharepoint",
  "execute_mom_increment_sharepoint",
  "execute_increment_analysis_sharepoint",
  "execute_salary_analytical",
  "execute_actuary_testing",
]);

export function isNoopPayrollExecuteScript(scriptKey: string): boolean {
  if (WEB_ARCHIVE_NOOP_EXECUTE_SCRIPTS.has(scriptKey)) return true;
  if (scriptKey.startsWith("execute_share_based_payment_")) return true;
  return false;
}
